import {observer} from "mobx-react";
import React from "react";
import {ExpandComponentProps} from "../../core/grid/component/gridComp";
import ProjectVersionLop from "../domain/project/projectVersionLopDomain";
import {loc} from "../../core/common/config/locales";


@observer
export default class ProjectVersionLopMaterialExpandComp extends React.Component<ExpandComponentProps, any> {

  render(): JSX.Element | false | null {

    const {item} = this.props;
    const lop = item.rowObject as ProjectVersionLop;
    const {frameMaterial1, frameMaterial1Mass, frameMaterial2, frameMaterial2Mass,
      frameMaterial3, frameMaterial3Mass, frameMaterial4, frameMaterial4Mass, frameMaterial5, frameMaterial5Mass,
      glazingMaterial, glazingMaterialMass} = lop;

    return (
      <div>
        {
          frameMaterial1 &&
          <div>
            <p>{loc.i18n`LOP frame material`}</p>
            <ul>
              {
                frameMaterial1 && frameMaterial1Mass &&
                <li>{frameMaterial1.label} : {frameMaterial1Mass} kg</li>
              }
              {
                frameMaterial2 && frameMaterial2Mass &&
                <li>{frameMaterial2.label} : {frameMaterial2Mass} kg</li>
              }
              {
                frameMaterial3 && frameMaterial3Mass &&
                <li>{frameMaterial3.label} : {frameMaterial3Mass} kg</li>
              }
              {
                frameMaterial4 && frameMaterial4Mass &&
                <li>{frameMaterial4.label} : {frameMaterial4Mass} kg</li>
              }
              {
                frameMaterial5 && frameMaterial5Mass &&
                <li>{frameMaterial5.label} : {frameMaterial5Mass} kg</li>
              }
            </ul>
          </div>
        }
        {
          glazingMaterial && glazingMaterialMass &&
          <div>
            <p>{loc.i18n`LOP glazing material`}</p>
            <ul>
              <li>{glazingMaterial.label} : {glazingMaterialMass} kg</li>
            </ul>
          </div>
        }
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/sbtool/component/projectVersionLopMaterialExpandComp.tsx